interface Named {
  name?: string;
}

export function sortByName(a?: Named, b?: Named) {
  const nameA = a?.name;
  const nameB = b?.name;
  if (!nameA && !nameB) {
    return 0;
  }
  if (!nameA) {
    return 1;
  }
  if (!nameB) {
    return -1;
  }
  return nameA.localeCompare(nameB);
}

interface Labeld {
  label?: string | null;
}

export function sortByLabel(a?: Labeld, b?: Labeld) {
  const nameA = a?.label;
  const nameB = b?.label;
  if (!nameA && !nameB) {
    return 0;
  }
  if (!nameA) {
    return 1;
  }
  if (!nameB) {
    return -1;
  }
  return nameA.localeCompare(nameB);
}

interface FirstNamed {
  firstName?: string | null;
}

export function sortByFirstName(a?: FirstNamed, b?: FirstNamed) {
  const nameA = a?.firstName;
  const nameB = b?.firstName;
  if (!nameA && !nameB) {
    return 0;
  }
  if (!nameA) {
    return 1;
  }
  if (!nameB) {
    return -1;
  }
  return nameA.localeCompare(nameB);
}
